import { VISORIA_STORE_IMAGES } from "../../images/visoria";

export const MAX_OTHER_STORE_QUANTITY = 10;

/** Предпочтительный порядок регионов в селекте (остальные — как пришли с API). */
const REGION_ORDER_BY_STORE = {
  nintendo: ["usd", "pln"],
  playstation: ["pln", "usd"],
};

const REGION_ID_ALIASES = {
  usd: ["usd", "us"],
  pln: ["pln", "pl"],
};

const REGION_LABEL_BY_KEY = {
  usd: "США",
  pln: "Польша",
};

function regionMatchesKey(region, key) {
  const id = String(region?.id || "").toLowerCase();
  if (REGION_ID_ALIASES[key]?.includes(id)) {
    return true;
  }
  return region?.label === REGION_LABEL_BY_KEY[key];
}

/** Поднимает нужные регионы вверх; для PlayStation первый = дефолт. */
export function orderStoreRegions(store) {
  if (!store?.regions?.length) {
    return store;
  }
  const priority = REGION_ORDER_BY_STORE[store.id];
  if (!priority) {
    return store;
  }

  const preferred = [];
  const used = new Set();
  for (const key of priority) {
    const region = store.regions.find(
      (item) => !used.has(item.id) && regionMatchesKey(item, key),
    );
    if (region) {
      preferred.push(region);
      used.add(region.id);
    }
  }
  if (!preferred.length) {
    return store;
  }

  return {
    ...store,
    regions: [
      ...preferred,
      ...store.regions.filter((item) => !used.has(item.id)),
    ],
  };
}

export function attachStoreImage(store) {
  if (!store) {
    return null;
  }
  const withImage = {
    ...store,
    image: VISORIA_STORE_IMAGES[store.id] ?? null,
  };
  return orderStoreRegions(withImage);
}

export function attachStoreListImages(stores) {
  return stores.map((store) => attachStoreImage(store));
}

export function getMaxPurchasableQuantity(stockAvailable) {
  if (!Number.isFinite(stockAvailable) || stockAvailable <= 0) {
    return 0;
  }
  return Math.min(MAX_OTHER_STORE_QUANTITY, stockAvailable);
}

export function formatRubPrice(amount) {
  return `${Math.round(amount).toLocaleString("ru-RU")} ₽`;
}

export function formatUsdtPrice(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return "— USDT";
  }
  return `${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} USDT`;
}

export async function copyTextToClipboard(text) {
  const value = String(text || "");
  if (!value) {
    return false;
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Fallback below for HTTP or denied permissions.
  }

  try {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);
    return copied;
  } catch {
    return false;
  }
}
